<template>
  <div class="category-form">
    <el-form
      ref="ruleForm"
      label-width="200px"
      class="stepTwo-ruleForm"
      :model="ruleForm"
      :rules="rules"
      inline-message
      size="mini"
      :disabled="status === 1"
    >
      <!-- 主营类目 -->
      <el-form-item label="主营类目：" class="tree">
        <el-row :gutter="24">
          <el-col :span="4">
            <el-form-item class="mgb0">
              <el-button class="mi-primary" :disabled="status === 1" @click="showTree">选择类目</el-button>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item prop="categoryId" class="mgb0">
              <el-button class="mi-info" :disabled="status === 1" @click="choiceSure">确定</el-button>
              <el-tree
                v-if="isShowTree && categories.length"
                ref="treeForm"
                size="mini"
                :default-checked-keys="ruleForm.categoryId"
                :data="categories"
                :props="categoryProps"
                node-key="id"
                show-checkbox
                icon-class="el-icon-arrow-right"
                @check-change="handleCheckChange"
              ></el-tree>
              <div v-if="treeOne.length" class="left100">{{ treeOne }}&nbsp;|&nbsp;{{ treeTwo }}&nbsp;|&nbsp;{{ treeThree.join(',') }}</div>
            </el-form-item>
          </el-col>
          <el-col :span="16">
            <span>选择类目仅支持同一个二级分类下选择多个三级类目</span>
          </el-col>
        </el-row>
      </el-form-item>

      <!-- 资质列表 -->
      <el-form-item v-if="ruleForm.qualifications.length" class="qualifications-wrap">
        <el-form-item label="类目资质列表上传："></el-form-item>
        <el-form-item v-for="(item, index) in ruleForm.qualifications" :key="item.id" class="pic-list">
          <el-form-item :label="item.name +'：'" class="pic" :prop="`qualifications[${index}].objectId`">
            <span class="download-tips">图片尺寸<span class="highlight">800px*800px</span>以上，大小不超过<span class="highlight">1M</span>，格式<span class="highlight">png/jpg/jpeg</span>，需在扫描件上加盖<span class="highlight">红章</span>后上传。</span>
            <el-upload
              v-model="item.objectId"
              class="avatar-uploader"
              :class="[item.objectId ? 'active' : 'inactive']"
              action=""
              accept="image/*"
              :disabled="status === 1"
              :show-file-list="false"
              :http-request="ctx => categoryImageUpload(ctx, index)"
              :before-upload="beforeImageUpload()"
            >
              <div v-if="status !== 1 && item.objectId" class="btn-close" @click.stop="removeImage(item, 'objectId')">
                <img src="@/assets/img/icon-close.png">
              </div>
              <img v-if="item.objectId" :src="encodeImgURl(item.objectId)" class="avatar">
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </el-form-item>
          <el-form-item label="资质证书有效期：" class="date" required>
            <el-col :span="6">
              <el-form-item :prop="`qualifications[${index}].startDate`" :rules="timeRules.startDate">
                <el-date-picker
                  v-model="item.startDate"
                  :disabled="status === 1 || item.longTermEffective"
                  value-format="yyyy-MM-dd"
                  type="date"
                  placeholder="选择日期"
                  :picker-options="{disabledDate(time) {
                    return time.getTime() > Date.now()
                  }}"
                ></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="1" style="textAlign: center">-</el-col>
            <el-col :span="6">
              <el-form-item :prop="`qualifications[${index}].endDate`" :rules="timeRules.endDate">
                <el-date-picker
                  v-model="item.endDate"
                  :disabled="status === 1 || item.longTermEffective"
                  value-format="yyyy-MM-dd"
                  type="date"
                  placeholder="选择日期"
                  :picker-options="{disabledDate(time) {
                    return time.getTime() < Date.now()
                  }}"
                ></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="3" style="marginLeft: 10px">
              <el-checkbox v-model="item.longTermEffective" :disabled="status === 1" @change="longTime(index)">长期有效</el-checkbox>
            </el-col>
          </el-form-item>
          <div v-show="reasons.qualifications[index]" class="reason">驳回原因：{{ reasons.qualifications[index] }}</div>
        </el-form-item>
      </el-form-item>

      <el-form-item v-if="!isShowTree" class="form-footer">
        <el-button v-if="status === 0" class="mi-primary-plain" @click="lastAllStep()">上一步</el-button>
        <el-button
          v-if="status === 0"
          class="mi-primary"
          :disabled="saveBtnDisabled"
          @click="submitForm('ruleForm')"
        >
          保存并下一步
        </el-button>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import { upload } from '@mi/upload'
import { mapMutations, mapState } from 'vuex'
import { deepCopy, shallowMerge } from '@/utils'
import { getCategory, postCategory, getCategoryQualification } from '@/api/merchant'
import { processMixin } from '@/common/mixin'

export default {
  mixins: [processMixin],
  props: {
    // 表单状态，0:填写阶段 1:禁止修改 2:可以修改
    status: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      saveBtnDisabled: false,
      isShowTree: false,
      categories: [],
      qualificationIds: '',
      categoryProps: {
        value: 'id',
        label: 'name',
        children: 'subCategories'
      },
      ruleForm: {
        categoryId: [],
        qualifications: []
      },
      reasons: {
        qualifications: []
      },
      timeRules: {
        startDate: [{
          required: false,
          message: '请选择有效开始日期',
          trigger: 'change'
        }],
        endDate: [{
          required: false,
          message: '请选择有效结束日期',
          trigger: 'change'
        }]
      },
      lastCategoryId: [],
      firstAssign: true,
      treeOne: [],
      treeTwo: [],
      treeThree: [],
      rules: {
        categoryId: [{ required: true, message: '请选择类目', trigger: '' }]
      }
    }
  },

  computed: {
    ...mapState({
      merchantData: state => state.merchantData
    })
  },

  watch: {
    'ruleForm.qualifications'(list) {
      list.forEach((item, index) => {
        let qualifications = `qualifications[${index}].objectId`
        this.rules[qualifications] = [
          {
            required: true,
            message: `请上传${item.name}`,
            trigger: 'change'
          }
        ]
      })
    }
  },

  async mounted() {
    await this.getCategoryInfo()
    if (this.merchantData && this.merchantData.category) {
      const data = this.merchantData.category
      this.categories.forEach(item => {
        item.subCategories &&
          item.subCategories.forEach(p => {
            p.subCategories &&
              p.subCategories.forEach(f => {
                if (data.categoryId) {
                  if (data.categoryId.includes(f.id)) {
                    this.treeThree.push(f.name)
                    this.treeTwo = p.name
                    this.treeOne = item.name
                  }
                }
              })
          })
      })
      if (data.categoryId) this.ruleForm.categoryId = data.categoryId.split(',').map(t => parseInt(t))
      if (this.ruleForm.categoryId.length > 0) {
        this.getQualification().then(res => {
          if (!res.code) {
            this.ruleForm.qualifications = deepCopy(data.qualifications)
            const { qualification } = res.data
            this.ruleForm.qualifications.forEach(item => {
              qualification.forEach(p => {
                if (item.id === p.id) {
                  item.name = p.name
                  item.desc = p.desc
                }
              })
            })
            if (data.reviewDetail && data.reviewDetail.qualifications) {
              const list = data.reviewDetail.qualifications
              const reasons = []
              this.ruleForm.qualifications.map(t => {
                const item = list.find(p => p.qualificationId === t.id)
                if (item && item.review.reject) reasons.push(item.review.remark)
                else reasons.push('')
              })
              this.reasons.qualifications = reasons
              this.$emit('updateReasonCount', 'categoryForm', reasons.reduce((acc, cur) => acc + (cur ? 1 : 0), 0))
            }
            this.firstAssign = false
          }
        })
      } else this.firstAssign = false
    }
  },

  methods: {
    ...mapMutations({
      setStepIndex: 'SET_STEP_INDEX',
      setContactIndex: 'SET_CONTACT_INDEX',
      setMerchantData: 'SET_MERCHANT_DATA'
    }),
    handleCheckChange(data, checked, indeterminate) {
      this.treeOne = []
      this.treeTwo = []
      this.treeThree = []
      this.lastCategoryId = this.ruleForm.categoryId
      let parentIds = []
      const checkData = this.$refs.treeForm.getCheckedNodes()

      for (let data of checkData) {
        if (!data.subCategories) {
          this.treeThree.push(data.name)
          data.parentId && parentIds.push(data.parentId)
        }
      }
      parentIds = Array.from(new Set(parentIds))

      if (checked && parentIds.length > 1) {
        this.$message.error('不能跨一级类目经营/同一级分类不能跨二级类目经营')
        this.$refs.treeForm.setCheckedNodes([])
        this.$refs.treeForm.setCheckedNodes([data])
      }
      this.$nextTick(() => {
        this.$refs.ruleForm.clearValidate(['categoryId'])
        this.ruleForm.categoryId = this.$refs.treeForm.getCheckedKeys(true)
        if (this.categories) {
          this.categories.forEach(item => {
            if (item.subCategories) {
              item.subCategories.forEach(p => {
                if (p.id === parentIds[0]) {
                  this.treeOne = item.name
                  this.treeTwo = p.name
                }
              })
            }
          })
        }
      })
    },
    showTree() {
      this.isShowTree = true
    },
    choiceSure() {
      const lastIds = this.lastCategoryId.sort(this._sortBy).toString()
      const nowIds = this.ruleForm.categoryId.sort(this._sortBy).toString()
      if (!this.ruleForm.categoryId || !this.ruleForm.categoryId.length) return this.$message.error('请选择类目信息')
      if (lastIds !== nowIds) this.getQualification()
      this.isShowTree = false
    },
    handleImageSuccess(index = 0) {
      return (res, file, fileList) => {
        const { code } = res
        if (!code) {
          this.ruleForm.qualifications[index].objectId = res.data.objectId
        } else {
          this.$message.error('上传失败，请重试')
        }
        this.$refs.ruleForm.validateField([`qualifications[${index}].objectId`])
      }
    },
    async categoryImageUpload(ctx, index) {
      try {
        const { code, data } = await upload({
          file: ctx.file,
          sourceService: 'youpin_zhaoshang', // 服务名称，默认'test,上线时需要改成youpin_zhaoshang
          bucket: 'private' // 需要私有
        })
        if (!code) {
          this.ruleForm.qualifications[index].objectId = data.url || ''
        } else {
          this.$message.error('上传失败，请重试')
        }
        this.$refs.ruleForm.validateField([`qualifications[${index}].objectId`])
      } catch (e) {
        this.$message.error(e)
      }
    },
    async getQualification() {
      const info = await getCategoryQualification({
        categoryIds: this.ruleForm.categoryId.join(',')
      })
      if (!info.code) {
        const { qualification } = info.data
        this.ruleForm.qualifications = qualification.map(item => {
          item.objectId = ''
          item.startDate = ''
          item.endDate = ''
          item.longTermEffective = false
          return item
        })
      } else {
        this.$message.error(info.msg || '服务器错误，请重试')
      }
      return info
    },
    // 获取资质信息
    async getCategoryInfo() {
      try {
        const info = await getCategory()
        const { code, data, msg } = info
        if (!code) {
          this.categories = data.categories.map(item => {
            item.disabled = true
            return item
          })
        } else this.$message.error(msg || '服务器错误')
      } catch (e) {
        this.$message.error(JSON.stringify(e))
      }
    },
    // 长期有效，校验清除
    longTime(index) {
      const longTermEffective = this.ruleForm.qualifications[index]
        .longTermEffective
      if (longTermEffective) {
        this.timeRules.startDate = {
          required: false
        }
        this.timeRules.endDate = {
          required: false
        }
        this.$refs.ruleForm.clearValidate([
          `qualifications[${index}].startDate`,
          `qualifications[${index}].endDate`
        ])
      } else {
        this.timeRules = {
          startDate: [
            {
              required: true,
              message: '请选择有效开始日期',
              trigger: 'change'
            }
          ],
          endDate: [
            {
              required: true,
              message: '请选择有效结束日期',
              trigger: 'change'
            }
          ]
        }
      }
    },
    submitForm(formName, jump = true) {
      return new Promise((resolve, reject) => {
        const longTermEffectiveIndex = this.ruleForm.qualifications.findIndex(item => item.longTermEffective)
        if (longTermEffectiveIndex !== -1) {
          this.timeRules.startDate = { required: false }
          this.timeRules.endDate = { required: false }
          this.$refs.ruleForm.clearValidate([
            `qualifications[${longTermEffectiveIndex}].startDate`,
            `qualifications[${longTermEffectiveIndex}].endDate`
          ])
        } else {
          this.timeRules = {
            startDate: [{ required: true, message: '请选择有效开始日期', trigger: 'change' }],
            endDate: [{ required: true, message: '请选择有效结束日期', trigger: 'change' }]
          }
        }
        setTimeout(() => {
          this.$refs[formName].validate(async valid => {
            if (valid) {
              const params = {
                categoryId: this.ruleForm.categoryId.join(','),
                qualifications: this.ruleForm.qualifications
              }
              this.saveBtnDisabled = true
              const info = await postCategory(params)
              this.saveBtnDisabled = false
              if (!info.code) {
                this.setMerchantData(shallowMerge({ category: params }, this.merchantData))
                if (jump) {
                  this.setStepIndex(2)
                }
                resolve()
              } else {
                this.$message.error(info.msg || '提交失败，请重试')
                reject()
              }
            } else {
              reject()
              return false
            }
          })
        }, 20)
      })
    },
    lastAllStep() {
      this.setStepIndex(0)
      this.setContactIndex(2)
    },
    /**
     * @name removeImage
     * @description 删除图片按钮
     */
    removeImage(ruleForm, key) {
      ruleForm[key] = null
    }
  }
}
</script>
<style lang="less">
.category-form {
  min-height: 570px;
  padding-bottom: 20px;

  .stepTwo-ruleForm {
    .submit-wrap {
      margin-top: 20px;
    }
  }

  .tree {
    margin-bottom: 0;
  }

  .mgb0 {
    margin-bottom: 0;
  }

  .el-checkbox-group {
    .el-checkbox {
      margin-left: 0;
    }
  }

  .el-tree,
  .left100 {
    transform: translateX(-100px);
    color: #606266;
  }

  .left100 {
    width: 700px;
  }

  .pic-list {
    padding-top: 10px;
    // margin-bottom: 0;
    border: 1px dashed #dbdbdb;
    .date {
      margin-bottom: 0 !important;
    }
    .el-form-item__content {
      margin-left: 0 !important;
      .avatar-uploader {
        margin-left: 200px;
      }
      .pic .el-form-item__error {
        padding-left: 190px;
      }
    }
    .el-col {
      text-align: left;
      padding: 0;
    }
    .el-col-6 {
      width: 160px;
    }
  }

  .qualifications-wrap {
    margin-bottom: 0;
    .el-form-item__content {
      margin-left: 0px !important;
    }
  }

  .reason {
    font-size: 13px;
    line-height: 16px;
    color: #E00C0C;
    padding-left: 50px;
    padding-bottom: 10px;
  }
}
</style>
